import API from './API';

const path = `enums`;

const EnumService = {
    listarSexos: async () => await API.list(`${path}/sexos`),
    listarRacas: async () => await API.list(`${path}/racas`),
    listarNecessidadesEspeciais: async () => await API.list(`${path}/necessidades-especiais`),
    listarStatusValidacao: async () => await API.list(`${path}/status-validacao`),
    listarStatusCandidato: async () => await API.list(`${path}/status-candidato`),
    listarStatusProva: async () => await API.list(`${path}/status-prova`),
    listarSituacoesProvaCandidato: async () => await API.list(`${path}/situacoes-prova-candidato`),
    listarPerfis: async () => await API.list(`${path}/perfis`),
    listarDependenciasAdministrativas: async () => await API.list(`${path}/dependencias-administrativas`),
    listarTiposVariavel: async () => await API.list(`${path}/tipos-variavel`),
    listarAgrupamentos: async () => await API.list(`${path}/agrupamento`),
    listarTiposEmail: async () => await API.list(`${path}/tipos-email`),
    listarTiposDocumento: async () => await API.list(`/tipos-documentos`),
    listarAnosLetivos: async () => await API.list(`${path}/anos-letivos`),
    listarStatusTratamentoInvalidacao: async () => await API.list(`${path}/status-tratamento-invalidacao`),
    listarMotivosInvalidacao: async () => await API.list(`${path}/motivos-invalidacao`),
    listarMomentosDigitacao: async () => await API.list(`${path}/momentos-digitacao`),
}

export default EnumService;